import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CmaApi {
  private prospektrBackendBaseURL = environment.prospektrBackendBaseURL;
  private getCmaReportByIdApi = 'cmaReport';
  private getCmaReportForInvestorApi = 'cmaReportForInvestor';
  private smartReportApi = 'generateSmartReport';

  constructor(private http: HttpClient) { }

  createCMAReport(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.getCmaReportByIdApi}`, params);
  }

  createSmartReport(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.smartReportApi}`, params);
  }

  requestHomeValue(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.getCmaReportForInvestorApi}`, params);
  }

  getAllCmaReports(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}getAllCmaReports`, params);
  }

  getCmaReportById(id) {
    return this.http.get(`${this.prospektrBackendBaseURL}${this.getCmaReportByIdApi}/${id}`);
  }

  deleteReport(params): Observable<any> {
    return this.http.delete(`${this.prospektrBackendBaseURL}${this.getCmaReportByIdApi}`, {
      params: params,
    });
  }
  shareCmaReport(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}shareCmaReport`, params);
  }

  shareCmaReportStatistics(): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}cmaReportStatistics`, {});
  }

  addSharedUserId(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}updateSharedCmaReport`, params);
  }
  addSharedUserIdInValuetestReport(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}updateSharedValuetestReport`, params);
  }

  getSharedCmaReport(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}getSharedReport`, params);
  }

  getCmaReportCount(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}getCmaReportCount`);
  }

  getSmartReportCount(): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}getSmartReportsCount`);
  }

  getCmaFetchComparables(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}fetchCmaComparables`, params);
  }

  saveSelectedComparables(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}saveSelectedComparables`, params);
  }

  saveAdjustments(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}saveAdjustments`, params);
  }

  saveAdjustedValueSelection(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}saveAdjustedValueSelection`, params);
  }
}
